<template>
  <button class="button is-link is-light" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-edit"></i>
    </span>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/EditButton.vue